import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, SUBSCRIPTIONS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'subscription',
  url: `${SUBSCRIPTIONS_URL}/:id`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
